const FeedComponentsMap = require("../classes/feed-components-map");
const { declaredComponentReferenceKeys } = require("./declared-app-option-keys");
const { COMPLETION_CARD_OPTION_KEYS } = require("../constants/completion-card-option-keys");

const REFERENCED_COMPONENT_ID_KEY = "referenced-component-id";
const FEED_COMPONENT_KEY = FeedComponentsMap.OPTION_KEY;
// Mirrors DcDependencyWalker::NESTED_COMPONENT_REFERENCE_OPTION_KEYS' list-shaped member.
const FEED_ROW_CONDITIONS_KEY = "feed-row-conditions";
const EMBEDDED_COMPONENT_ID_KEYS = [
  "resume-story-card-id",
  "resume-empty-card-id",
  // Feeds (V1 Feed + V2 FeedV2Element) rendering a designer-built component as
  // their empty state instead of `empty-state-text`.
  "empty-state-component-id",
  // Feeds rendering a designer-built component as their section header.
  "feed-separators-component-id",
  // Feeds drawing a designer-built component above the first unseen row.
  "feed-last-seen-component-id",
  // XXX: The completion card overrides were ABSENT here, so a completion
  // XXX: element's bound component never entered the compiled closure and
  // XXX: rendered InvalidElement on staging -- while the builder canvas painted
  // XXX: it fine off the global cumulative registry. Derived from
  // XXX: constants/completion-card-option-keys.js, never retyped.
  ...COMPLETION_CARD_OPTION_KEYS,
];

function embeddedComponentIdKeys() {
  return [...EMBEDDED_COMPONENT_ID_KEYS, ...declaredComponentReferenceKeys()];
}

// Mirrors DcDependencyWalker's constants (REFERENCED_OPTION_KEY, FEED_OPTION_KEY,
// reference but this list omits is a reference the builder cannot flag as broken,
function readNumericId(raw) {
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : 0;
}

function unwrapLeaf(leaf) {
  if (leaf && typeof leaf === "object" && "r" in leaf) {
    return leaf.r;
  }
  return leaf;
}

// it. Shape: [{ optionKey, componentId }].
function componentReferencesOf(readOption) {
  const references = [];
  const pushId = (optionKey, raw) => {
    const componentId = readNumericId(raw);
    if (componentId) {
      references.push({ optionKey, componentId });
    }
  };

  pushId(REFERENCED_COMPONENT_ID_KEY, unwrapLeaf(readOption(REFERENCED_COMPONENT_ID_KEY)));

  embeddedComponentIdKeys().forEach(key => pushId(key, unwrapLeaf(readOption(key))));

  references.push(...FeedComponentsMap.componentReferences(unwrapLeaf(readOption(FEED_COMPONENT_KEY))));

  const conditions = unwrapLeaf(readOption(FEED_ROW_CONDITIONS_KEY));
  (Array.isArray(conditions) ? conditions : []).forEach((condition, index) => {
    pushId(`${FEED_ROW_CONDITIONS_KEY}.${index}`, condition?.componentId);
  });

  return references;
}

module.exports = {
  REFERENCED_COMPONENT_ID_KEY,
  FEED_COMPONENT_KEY,
  FEED_ROW_CONDITIONS_KEY,
  EMBEDDED_COMPONENT_ID_KEYS,
  embeddedComponentIdKeys,
  componentReferencesOf,
};
